import { render, staticRenderFns } from "./CommercialLogDemoTable.vue?vue&type=template&id=d383be74"
import script from "./CommercialLogDemoTable.vue?vue&type=script&lang=js"
export * from "./CommercialLogDemoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports